import styled from 'styled-components';
import bg from '../../../images/page_2_bg.png';


export const Wrapper = styled.div`
  background: #323467 url(${bg});
  background-size: cover;
  backdrop-filter: opacity(0.1);
  color: #FFF;
`;